import { initDropdownMenus } from "../utilities/dropdownToggle";
import { parents } from "../utilities/selectorHelper";
import { scrollToElement } from "../utilities/scrollToElement";
import { SCROLL_TIMER_10MS } from "../utilities/constants";

const {refreshStickyWrapperHeight} = require("../utilities/stickyHelpers");
var keyboardAccessibility = require("./keyboardAccessibility");
var $cache = {
    window: $(window),
    document: $(document),
    html: $("html"),
    body: $("body"),
    mainMenu: $(".main-menu"),
    modalBackground: $(".js-modal-bg"),
    windowWidth: $(window).width()
};
var debounce = require("lodash/debounce");
const mqueryRespond = window.mqRespond;
const SEE_ALL_BORDER_HEIGHT = 1;

const brandID = $(".header").data("brandid");
const powerCategoriesEnabled = $(".menu-group").data("powercategories");

if (powerCategoriesEnabled) {
    $(".container-dropdown-first-column").css({"float": "left"});
    $(".container-dropdown-first-column").css({"width": "315px"});
    $("li.nav-item.dropdown > ul").css({"min-height": "722px"});
}

/**
 * @function
 * @description - Increase/decrease the menu height, depending on the number of the items to be displayed
 */
var adjustMenuDimensions = function () {
    let $displayedDropdowns = $(".dropdown-menu.show"),
        $navigationBanner = $(".navigation-banner"),
        maxHeight = 0;

    $displayedDropdowns.each(function () {
        let $this = $(this),
            $dropdownItem = $this.find("> li.dropdown-item"),
            dropdownLevel = $this.parents(".dropdown-menu").length,
            dropdownListHeight = 0;

        $dropdownItem.each((index, el) => {
            dropdownListHeight += $(el).outerHeight(true);
        });

        if (dropdownListHeight > maxHeight) {
            maxHeight = dropdownListHeight;

            if (dropdownLevel > 0) {
                maxHeight += SEE_ALL_BORDER_HEIGHT;
            }
        }
    });

    const $displayedFirstColumn = $(".container-dropdown-first-column");

    let $dropdownItem = $displayedFirstColumn.find("> li.dropdown-item"),
        dropdownLevel = $displayedFirstColumn.parents(".dropdown-menu").length,
        dropdownListHeight = 0;

    $dropdownItem.each((index, el) => {
        dropdownListHeight += $(el).outerHeight(true);
    });

    if (powerCategoriesEnabled) {
        const $displayedSecondColumn = $(".container-dropdown-second-column");
        let secondColumnHeight = $displayedSecondColumn.outerHeight(true);

        if (secondColumnHeight < maxHeight && secondColumnHeight < dropdownListHeight) {
            $displayedDropdowns.css({"min-height": "0px"});

            if (dropdownListHeight > maxHeight) {
                maxHeight = dropdownListHeight;

                if (dropdownLevel > 0) {
                    maxHeight += SEE_ALL_BORDER_HEIGHT;
                }
            }
        } else if (secondColumnHeight > maxHeight && secondColumnHeight > dropdownListHeight) {
            maxHeight = secondColumnHeight;
        }
    } else {
        if (dropdownListHeight > maxHeight) {
            maxHeight = dropdownListHeight;

            if (dropdownLevel > 0) {
                maxHeight += SEE_ALL_BORDER_HEIGHT;
            }
        }
    }

    if (powerCategoriesEnabled) {
        $displayedDropdowns.css("height", maxHeight < $(".navigation-banner").outerHeight(true) && $navigationBanner.hasClass("show") ? $(".navigation-banner").outerHeight(true) : maxHeight);

        $(".row.descubra-mais").css("height", $(".dropdown-menu.item-shadow.has-before.show").outerHeight());

        if (dropdownLevel > 0 && $(".navigation-banner").outerHeight(true) > $displayedDropdowns.outerHeight(true)) {
            $displayedDropdowns.css("height", $(".navigation-banner").outerHeight(true));

            $navigationBanner.css("height", maxHeight < $(".navigation-banner").outerHeight(true) && $navigationBanner.hasClass("show") ? $(".navigation-banner").outerHeight(true) : maxHeight);
        }

        if ($(".container-dropdown-second-column").hasClass("d-none")) {
            $navigationBanner.css("height", maxHeight > $(".navigation-banner").outerHeight(true) && $navigationBanner.hasClass("show") ? maxHeight : $(".navigation-banner").outerHeight(true));
        }

    } else {
        $displayedDropdowns.css({"min-height": "0px"});
        $navigationBanner.css("height", maxHeight);
        $displayedDropdowns.css("height", maxHeight < $navigationBanner.outerHeight(true) && $navigationBanner.hasClass("show") ? $navigationBanner.outerHeight(true) : maxHeight);
    }
};

function selectParent($parent) {
    const $parentId = $parent.attr("aria-label");
    if ($parentId && $parentId.length > 0) {
        let $parentElement = $("#"+$parentId);
        $parentElement.addClass("pwc-font--primary-bold");
        const $thisParent = $parentElement.closest("ul");
        if ($thisParent && $thisParent.length > 0) {
            selectParent($thisParent);
        }
    }
}

const initMenu = () => {
    var isDesktop = function (element) {
        return $(element).parents(".menu-toggleable-left").css("position") !== "fixed";
    };

    var headerBannerStatus = window.sessionStorage.getItem("hide_header_banner");
    const $headerBanner = $(".js-header-banner");

    /*
    ** @description: Function that will toggle the sub levels in the main menu
    ** @param: element -> DOM element, click triggered
    */
    const submenuMainToggle = element => {
        var $navbar = element.closest(".navbar-nav"),
            $staticNavElement = $navbar.find(".static-nav-item"),
            categoryID = element.data("category"),
            $closestDropdown = element.closest(".dropdown-toggle-menu"),
            $closestNavItem = element.closest(".nav-item"),
            $firstDropdown = $closestNavItem.find(".dropdown-toggle-menu").eq(0),
            $previousBackLink = $closestDropdown.parent().find(".js-category-back").eq(0),
            $previousSeeAllLink = $closestDropdown.parent().find(".js-category-link").eq(0);

        $closestDropdown.children().toggleClass("toggle-hide");

        $(".nav-item-wrap[data-category='" + categoryID + "']").toggleClass("toggle-hide");
        $firstDropdown.toggleClass("toggle-hide").toggleClass("in");

        $staticNavElement.toggleClass("toggle-hide", $(".in").length > 0);

        if ($previousBackLink.data("category") != categoryID && $previousSeeAllLink.data("category") != categoryID) {
            $previousBackLink.add($previousSeeAllLink).toggleClass("toggle-hide");
        }

        // Handle menu slide animation on mobile and tablet
        if (mqueryRespond.status.mobile || mqueryRespond.status.tablet) {
            $closestNavItem.toggleClass("toggle-hide active-nav-item");
            let activeUlHeight = 0;
            let percentMultiplier = 100;
            const elementSelector = element.get(0);
            const backButtonClicked = elementSelector.classList.contains("js-category-back");
            const direction = backButtonClicked ? -1 : 0;
            const parentUl = parents(elementSelector, "ul");
            const level = parentUl.length - 1;
            const activeNavItem = parents(elementSelector, ".active-nav-item");
            const offset = (level + direction) * -percentMultiplier + "%";

            $navbar.find(".nav-item:not(.active-nav-item)").css("height", "auto");

            if (activeNavItem[0]) {
                activeNavItem[0].children.forEach(e => {
                    activeUlHeight += e.offsetHeight;
                });

                activeNavItem.forEach((e, i) => {
                    activeNavItem[i].style.height = `${activeUlHeight}px`;
                });
            }

            if (level == 2 && backButtonClicked) {
                $closestDropdown.removeAttr("style");
            } else if (level == 2) {
                $closestDropdown.css("top", "0");
            }

            $navbar.get(0).style.transform = `translateX(${offset})`;

            // scroll to top of container
            scrollToElement($(".main-menu-wrapper"), SCROLL_TIMER_10MS, $(".main-menu-wrapper"));
        }

        return;
    };

    const openParentInMenuMobile = parent => {
        const $parentUl = parent.closest("ul");
        if (parent && parent.length > 0 && parent.siblings().length > 0) {
            let $menuElement = $parentUl.siblings(".js-category-toggle");
            if ($parentUl && $parentUl.length > 0 && $parentUl.siblings().length > 0) {
                openParentInMenuMobile($menuElement);
            }

            submenuMainToggle(parent);
        }
        return;
    };

    $headerBanner.on("click", ".close", function () {
        const $this = $(this);

        $headerBanner.addClass("d-none");
        $this.tooltip("hide");
        window.sessionStorage.setItem("hide_header_banner", "1");
        refreshStickyWrapperHeight();
    });

    if (!headerBannerStatus || headerBannerStatus < 0) {
        $headerBanner.removeClass("d-none");
    }

    const isMobile = window.mqRespond.status.mobile;

    if (isMobile) {
        var currentUrl = window.location.origin + window.location.pathname;

        $(".main-menu .nav-link, .main-menu .dropdown-link").each(function (index, $category) {
            if ($category.href == currentUrl) {
                $(this).addClass("pwc-font--primary-bold");
                const $parentUl = $(this).closest("ul");
                if ($parentUl && $parentUl.length > 0) {
                    selectParent($parentUl);
                }
                let $parent = $(this).parent();
                if (this && $(this).closest(".mobile-menu-group").length > 0 && ($parent.hasClass("js-category-toggle") || $parent.hasClass("nav-item-single"))) {
                    let $parentCategoryToggle = $parent.closest("ul").siblings(".js-category-toggle");
                    if ($parentCategoryToggle.hasClass("js-category-toggle")) {
                        openParentInMenuMobile($parentCategoryToggle);
                        return false;
                    }
                }
            }
        });
    }

    keyboardAccessibility(".main-menu .nav-link, .main-menu .dropdown-link",
        {
            40: function (menuItem) { // down
                if (menuItem.hasClass("nav-item")) { // top level
                    $(".navbar-nav .show").removeClass("show item-shadow")
                        .children(".dropdown-menu")
                        .removeClass("show item-shadow");
                    menuItem.addClass("show item-shadow").children(".dropdown-menu").addClass("show item-shadow");
                    menuItem.find("ul > li > a")
                        .first()
                        .focus();
                } else {
                    menuItem.removeClass("show item-shadow").children(".dropdown-menu").removeClass("show item-shadow");
                    if (!(menuItem.next().length > 0)) { //NOSONAR
                        menuItem.parent().parent().find("li > a") // set focus to the first menuitem
                            .first()
                            .focus();
                    } else {
                        menuItem.next().children().first().focus();
                    }
                }
            },
            39: function (menuItem) { // right
                if (menuItem.hasClass("nav-item")) { // top level
                    menuItem.removeClass("show item-shadow").children(".dropdown-menu").removeClass("show item-shadow");
                    $(this).attr("aria-expanded", "false");
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass("dropdown")) {
                    menuItem.addClass("show item-shadow").children(".dropdown-menu").addClass("show item-shadow");
                    $(this).attr("aria-expanded", "true");
                    menuItem.find("ul > li > a")
                        .first()
                        .focus();
                }
            },
            38: function (menuItem) { // up
                if (menuItem.hasClass("nav-item")) { // top level
                    menuItem.removeClass("show item-shadow").children(".dropdown-menu").removeClass("show item-shadow");
                } else if (menuItem.prev().length === 0) { // first menuItem
                    menuItem.parent().parent().removeClass("show item-shadow")
                        .children(".nav-link")
                        .attr("aria-expanded", "false");
                    menuItem.parent().children().last().children() // set the focus to the last menuItem
                        .first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) { // left
                if (menuItem.hasClass("nav-item")) { // top level
                    menuItem.removeClass("show item-shadow").children(".dropdown-menu").removeClass("show item-shadow");
                    $(this).attr("aria-expanded", "false");
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest(".show").removeClass("show item-shadow")
                        .closest("li.show").removeClass("show item-shadow")
                        .children()
                        .first()
                        .focus()
                        .attr("aria-expanded", "false");
                }
            },
            27: function (menuItem) { // escape
                var parentMenu = menuItem.hasClass("show")
                    ? menuItem
                    : menuItem.closest("li.show");
                parentMenu.children(".show").removeClass("show");
                parentMenu.removeClass("show item-shadow").children(".nav-link")
                    .attr("aria-expanded", "false");
                parentMenu.children().first().focus();
            }
        },
        function () {
            return $(this).parent();
        }
    );

    /**
     * Toggle background overlay visibility for header navigation
     * and triggers sticky functionality for the header to enable scroll inside page
     * to be able to see all the categories
     *
     * @param {Boolean} turnOn
     */
    const toggleNavHelper = turnOn => {
        if (turnOn) {
            $cache.modalBackground.addClass("header-visible").show();
            $cache.body.addClass("d-navigation-open");
            if (mqueryRespond.status.desktop || mqueryRespond.status.desktopLarge) {
                $cache.window.trigger("scroll");
            }
        } else {
            $cache.modalBackground.removeClass("header-visible").hide();
            $cache.body.removeClass("d-navigation-open");
            $("header").find(".sticky-element").removeClass("sticky-paused");
            if (mqueryRespond.status.desktop || mqueryRespond.status.desktopLarge) {
                $cache.window.trigger("scroll");
            }
        }
    };

    var displayNavDropdown = debounce(function () {
        if (isDesktop(this)) {
            let $this = $(this);

            if ($this.is("a") && !$this.is("li") && powerCategoriesEnabled) {
                $this = $(this).parent("li");
            }

            var $dropdownEl = $this.find(".dropdown-menu").first(),
                $navigationBanner = $(".navigation-banner"),
                dropdownLevel = $this.parents(".dropdown-menu").length,
                isSameNode = $navigationBanner.parent().parent()[0].isEqualNode($this.parent()[0]);

            if (powerCategoriesEnabled && dropdownLevel == 0) {
                $this.children().find(".dropdown-item").removeClass("grey-icon");

                if (!$this.hasClass("show")) {
                    return;
                } else {
                    var $firstMenuDropdown = $this.children().find(".dropdown-menu.show");
                    $firstMenuDropdown.removeClass("show");
                    $(".navigation-banner").removeClass("show");
                }
            }

            if (!($this.parent().hasClass("container-dropdown-first-column") && ($this.parent().get(0).scrollHeight > ($this.parent().height() + 1)))) {
                $dropdownEl.addClass("has-before");
            }

            $this.add($dropdownEl).addClass("show");
            $this.siblings(".show").find(".dropdown-menu, .dropdown-item").removeClass("show");
            $this.siblings(".show").find(".dropdown-item").removeClass("grey-icon");
            $this.siblings().removeClass("show");
            $this.removeClass("grey-icon").siblings().addClass("grey-icon");

            if (!isSameNode) {
                $navigationBanner.detach().appendTo($this);
                $cache.body.trigger("kevelad:refresh");
            }

            if (dropdownLevel != 0) {
                if (powerCategoriesEnabled) {
                    $(".container-dropdown-second-column").addClass("d-none");
                    $("li.nav-item.dropdown > ul").css({"min-width": "315px"});
                    $(".container-dropdown-first-column").css({"width": "100%"});
                    $(".container-dropdown-first-column .dropdown-menu").css({"min-width": "315px"});
                }
                $navigationBanner.addClass("show");
            }
            else {
                if (powerCategoriesEnabled) {
                    $(".container-dropdown-first-column").css({"width": "315px"});
                    openDescubraMais();
                }

                $(".container-dropdown-first-column").scrollTop(0);
            }

            $this.children(".nav-link").attr("aria-expanded", "true");
            noDropdownItem.cancel();
            adjustMenuDimensions();
            toggleNavHelper(true);
        }
    }, 200);

    var noDropdownItem = debounce(function () {
        if (isDesktop(this)) {
            let $this = $(this),
                dropdownLevel = $this.parents(".dropdown-menu").length,
                $navigationBanner = $(".navigation-banner"),
                $closestDropdownItem = $this.closest(".dropdown-menu").parent();

            if (dropdownLevel == 1) {
                $navigationBanner.removeClass("show");
            }

            if (dropdownLevel > 1 && !$navigationBanner.parent()[0].isEqualNode($closestDropdownItem[0])) {
                $navigationBanner.detach().appendTo($closestDropdownItem);
                $cache.body.trigger("kevelad:refresh");
            }

            $this.siblings(".show").find(".dropdown-menu, .dropdown-item").removeClass("show");
            $this.siblings(".show").find(".dropdown-item").removeClass("grey-icon");
            $this.siblings().removeClass("show grey-icon");
            adjustMenuDimensions();
        }
    }, 200);

    if (powerCategoriesEnabled) {
        $(".container-dropdown-first-column>.dropdown:not(.disabled) [data-toggle=\"dropdown\"]")
            .on("click", function (e) {
                if (!isDesktop(this)) {
                    $cache.modalBackground.addClass("header-visible").show();
                    // copy parent element into current UL
                    var li = $("<li class=\"dropdown-item top-category\" role=\"button\"></li>");
                    var link = $(this).clone().removeClass("dropdown-toggle")
                        .removeAttr("data-toggle")
                        .removeAttr("aria-expanded")
                        .attr("aria-haspopup", "false");
                    li.append(link);
                    var closeMenu = $("<li class=\"nav-menu\"></li>");
                    closeMenu.append($(".close-menu").first().clone());
                    $(this).parent().children(".dropdown-menu")
                        .prepend(li)
                        .prepend(closeMenu)
                        .attr("aria-hidden", "false");
                    // copy navigation menu into view
                    $(this).parent().addClass("show item-shadow");
                    $(this).attr("aria-expanded", "true");
                    $(link).focus();
                    $("div.mobile-menu-group > ul.nav.navbar-nav > li.nav-item > a").attr("aria-hidden", "true");
                    $("div.menu-group > ul.nav.navbar-nav > li.nav-item > a").attr("aria-hidden", "true");
                    e.preventDefault();
                }
            })
            .parent();

        $(".nav-item.dropdown").on("click", displayNavDropdown);

        $(".dropdown:not(.disabled) [data-toggle=\"dropdown\"]").on("mouseenter", displayNavDropdown);

        $(".menu-group").on("mouseleave", debounce(function () {
            const $liNavMenuFirst = $(`#${brandID}-produtos`).closest("li");
            if ($liNavMenuFirst.hasClass("show")) {
                $liNavMenuFirst.children().find(".dropdown-item").removeClass("grey-icon");
                openDescubraMais();
            }
        }, 200));
    } else {

        $(".dropdown:not(.disabled) [data-toggle=\"dropdown\"]")
            .on("click", function (e) {
                if (!isDesktop(this)) {
                    $cache.modalBackground.addClass("header-visible").show();
                    // copy parent element into current UL
                    var li = $("<li class=\"dropdown-item top-category\" role=\"button\"></li>");
                    var link = $(this).clone().removeClass("dropdown-toggle")
                        .removeAttr("data-toggle")
                        .removeAttr("aria-expanded")
                        .attr("aria-haspopup", "false");
                    li.append(link);
                    var closeMenu = $("<li class=\"nav-menu\"></li>");
                    closeMenu.append($(".close-menu").first().clone());
                    $(this).parent().children(".dropdown-menu")
                        .prepend(li)
                        .prepend(closeMenu)
                        .attr("aria-hidden", "false");
                    // copy navigation menu into view
                    $(this).parent().addClass("show item-shadow");
                    $(this).attr("aria-expanded", "true");
                    $(link).focus();
                    $("div.mobile-menu-group > ul.nav.navbar-nav > li.nav-item > a").attr("aria-hidden", "true");
                    $("div.menu-group > ul.nav.navbar-nav > li.nav-item > a").attr("aria-hidden", "true");
                    e.preventDefault();
                }
            })
            .parent()
            .on("mouseleave", displayNavDropdown.cancel)
            .on("mouseenter", displayNavDropdown);
    }

    $(".dropdown-item:not(.dropdown)").on("mouseenter", noDropdownItem).on("mouseleave", noDropdownItem.cancel);

    function openDescubraMais() {
        $("li.nav-item.dropdown > ul").css({"min-height": "820px"});
        $(".container-dropdown-first-column .dropdown-menu").css({"min-width": "315px"});
        $(".row.descubra-mais").css("height", $(".dropdown-menu.item-shadow.has-before.show").outerHeight());
        $(".navigation-banner.item-shadow").removeClass("show");
        $(".container-dropdown-second-column").removeClass("d-none");
        $("li.nav-item.dropdown > ul").css({"min-width": "722px"});
        $(".container-dropdown-first-column").css({"width": "315px"});
        $(".container-dropdown-first-column").scrollTop(0);
        $("li.nav-item.dropdown.show > ul > div.container-dropdown-first-column > li.dropdown-item.dropdown.show > ul").removeClass("show");
        $(".dropdown-item.dropdown.show").removeClass("show");
    }

    function closeAllMenu() {
        const $this = $(this),
            $dropdownMenu = $(".dropdown-menu.item-shadow.has-before"),
            $navItemDropdown = $(".nav-item.dropdown"),
            $navBannerDropdown = $(".navigation-banner.item-shadow");

        $this.find(".dropdown, .dropdown-menu").removeClass("show grey-icon");
        $dropdownMenu.removeClass("show");
        $navItemDropdown.removeClass("show");
        $navBannerDropdown.removeClass("show");
        toggleNavHelper(false);
    }

    if (powerCategoriesEnabled) {
        $(`#${brandID}-produtos, .header-wrapper, .nav-item, .svg-inline.icon-arrow-down`).on("click", function () {
            openDescubraMais();
        });

        const isMobileOrTablet = window.mqRespond.status.mobile || window.mqRespond.status.tablet;
        if (!isMobileOrTablet) {
            $(".modal-background, .header").on("click", function (e) {
                if ($(e.target).is(".dropdown-menu.item-shadow") || $(e.target).is(".navigation-banner")) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                } else {
                    const $liNavMenuFirst = $(`#${brandID}-produtos`).closest("li");
                    if ($liNavMenuFirst.hasClass("show")) {
                        closeAllMenu();
                    } else {
                        let containingElement = document.querySelector(".main-menu");
                        if (containingElement.contains(e.target)) {
                            $liNavMenuFirst.addClass("show");
                        }
                    }
                }
            });
        }
    } else {
        $(".menu-group").on("mouseleave", function () {
            var $this = $(this),
                $navigationBanner = $(".navigation-banner");

            $this.find(".dropdown, .dropdown-menu").removeClass("show grey-icon");
            $navigationBanner.removeClass("show");
            toggleNavHelper(false);
        });
    }

    $(".navbar>.close-menu>.close-button").on("click", function (e) {
        e.preventDefault();
        $cache.modalBackground.removeClass("header-visible").hide();
        $(".navbar-toggler").focus();

        $cache.mainMenu.attr("aria-hidden", "true");
        $cache.mainMenu.siblings().attr("aria-hidden", "false");
        $("header").siblings().attr("aria-hidden", "false");
    });

    $(".menu-arrow-right").on("click", e => {
        if (mqueryRespond.status.mobile || mqueryRespond.status.tablet) {
            e.preventDefault();
            var $target = $(e.currentTarget);

            submenuMainToggle($target);
        }
    });

    $(".js-category-back").on("click", e => {
        e.preventDefault();
        var $target = $(e.currentTarget);

        submenuMainToggle($target);

        const $backArrow = $target.find(".menu-arrow-left");
        const tooltipID = $backArrow.attr("aria-describedby");

        $(`#${tooltipID}`).remove();
    });

    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    if (!isAndroid) {
        $("#input-custom-label-search").focus(function () {
            if ($(window).width() < 768) {
                const $qntInputCommentsDiv = $(".row.ct-pdp--favorite-addCTA");
                if (!$qntInputCommentsDiv.hasClass("d-none")) {
                    $qntInputCommentsDiv.addClass("d-none");
                }
            }
        }).focusout(function () {
            if ($("#suggestions-wrapper").children().length === 0) {
                const $qntInputCommentsDiv = $(".row.ct-pdp--favorite-addCTA");
                if ($qntInputCommentsDiv.hasClass("d-none")) {
                    $qntInputCommentsDiv.removeClass("d-none");
                }
            }
        });
    }

    document.querySelectorAll(".js-category-toggle .dropdown-link").forEach($category => {
        $category.addEventListener("click", e => {
            e.preventDefault();
            const $target = e.currentTarget;

            submenuMainToggle($($target.nextElementSibling));
        });
    });

    keyboardAccessibility(".navbar-header .user",
        {
            40: function ($popover) { // down
                if ($popover.children("a").first().is(":focus")) {
                    $popover.next().children().first().focus();
                } else {
                    $popover.children("a").first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children("a").first().is(":focus")) {
                    $(this).focus();
                    $popover.removeClass("show");
                } else {
                    $popover.children("a").first().focus();
                }
            },
            27: function () { // escape
                $(".navbar-header .user .popover").removeClass("show");
                $(".user").attr("aria-expanded", "false");
            },
            9: function () { // tab
                $(".navbar-header .user .popover").removeClass("show");
                $(".user").attr("aria-expanded", "false");
            }
        },
        function () {
            var $popover = $(".user .popover li.nav-item");
            return $popover;
        }
    );

    // L1 manageable links
    if (!powerCategoriesEnabled) {
        $cache.document.find(".js-link-manageable").on("mouseenter", () => {
            const $navigationBanner = $(".navigation-banner");
            const $menuGroup = $(".menu-group");

            $menuGroup.find(".dropdown, .dropdown-menu").removeClass("show grey-icon");
            $navigationBanner.removeClass("show");
            toggleNavHelper(false);
        });
    }

    // init My Account dropdown
    initDropdownMenus();

    // Handle "Produtos" nav in mobile
    const productsMenu = $(".products-menu");
    const descubraMaisMenu = $(".container-dropdown-second-column");
    const abaProductsDiv = $(".aba-produtos-div");
    const abaDescubraMaisDiv = $(".aba-descubra-mais-div");

    // handle click in "Produtos"
    $(".aba-produtos").on("click", function () {
        if (!descubraMaisMenu.hasClass("hide-descubra-mais-mobile")) {
            descubraMaisMenu.addClass("hide-descubra-mais-mobile");
        }
        productsMenu.removeClass("hide-descubra-mais-mobile");
        //remove red border line from descubra div
        if (abaDescubraMaisDiv.hasClass("active-menu-div")) {
            abaDescubraMaisDiv.removeClass("active-menu-div");
        }
        //add red border line to productos div
        if (!abaProductsDiv.hasClass("active-menu-div")) {
            abaProductsDiv.addClass("active-menu-div");
        }
    });
    // handle click in "Descubra +"
    $(".aba-descubra-mais").on("click", function () {
        if (!productsMenu.hasClass("hide-descubra-mais-mobile")) {
            productsMenu.addClass("hide-descubra-mais-mobile");
        }
        if (descubraMaisMenu.hasClass("hide-descubra-mais-mobile")) {
            descubraMaisMenu.removeClass("hide-descubra-mais-mobile");
        }
        //remove red border line from productos div
        if (abaProductsDiv.hasClass("active-menu-div")) {
            abaProductsDiv.removeClass("active-menu-div");
        }
        //add red border line to descubra div
        if (!abaDescubraMaisDiv.hasClass("active-menu-div")) {
            abaDescubraMaisDiv.addClass("active-menu-div");
        }
    });
};

export { initMenu };
